export default __webpack_public_path__ + "locales/sk/ChangeUserTypeDialog.json?hash=87b6c6482bea5df6bfca124051e3e7a8";